(() => {
  const init = (root) => {
    if (!root || root.dataset.avisReady === 'true') return;
    root.dataset.avisReady = 'true';

    const list = root.querySelector('[data-avis-list]');
    const pager = root.querySelector('[data-avis-pages]');
    const dialog = root.querySelector('[data-avis-dialog]');
    const filterBtn = root.querySelector('[data-avis-filter]');
    const sort = root.querySelector('.oskina-avis__sort');
    const src = root.dataset.avisSrc;
    const shop = root.dataset.avisShop || 'Oskina';
    const verifiedLabel = root.dataset.avisVerified || 'Achat vérifié';
    const prevLabel = root.dataset.avisPrev || 'Page précédente';
    const nextLabel = root.dataset.avisNext || 'Page suivante';
    const perPage = 15;
    const starSvg =
      '<svg viewBox="0 0 18 17" aria-hidden="true"><path fill="currentColor" d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z"/></svg>';
    let reviews = [];
    let original = [];
    let page = 1;

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');

    const stars = (rating) =>
      [1, 2, 3, 4, 5]
        .map((i) => `<span class="oskina-avis__star${i > rating ? ' oskina-avis__star--empty' : ''}">${starSvg}</span>`)
        .join('');

    const renderItems = () => {
      const start = (page - 1) * perPage;
      const slice = reviews.slice(start, start + perPage);
      list.innerHTML = slice
        .map((review) => {
          const photos = (review.images || [])
            .slice(0, 4)
            .map((url) => `<img src="${escapeHtml(url)}" alt="" width="72" height="72" loading="lazy">`)
            .join('');
          const reply = review.reply
            ? `<div class="oskina-avis__reply"><div class="oskina-avis__reply-head"><span class="oskina-avis__reply-logo">oskina</span><strong>${escapeHtml(shop)}</strong></div><div class="oskina-avis__reply-text">${escapeHtml(review.reply).replace(/\n/g, '<br>')}</div></div>`
            : '';
          return `<article class="oskina-avis__item">
            <div class="oskina-avis__item-stars" aria-hidden="true">${stars(review.rating || 5)}</div>
            <p class="oskina-avis__author">${escapeHtml(review.author)}</p>
            ${review.verified ? '<p class="oskina-avis__verified"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" fill="#3D5FC4" d="M8.19715 0.0515006C8.07469 -0.0171669 7.92532 -0.0171669 7.80287 0.0515006L6.21227 0.943783C6.15352 0.976691 6.08746 0.994399 6.02012 0.995235L4.19649 1.01781C4.0561 1.01958 3.92673 1.09425 3.85504 1.21496L2.92366 2.783C2.88926 2.84089 2.8409 2.88925 2.783 2.92363L1.21498 3.85502C1.09427 3.92673 1.01958 4.0561 1.01784 4.19648L0.995254 6.02011C0.994421 6.08745 0.976719 6.15351 0.943769 6.21224L0.0515167 7.80285C-0.0171722 7.92533 -0.0171722 8.07467 0.0515167 8.19715L0.943769 9.78776C0.976719 9.84649 0.994421 9.91255 0.995254 9.97989L1.01784 11.8035C1.01958 11.9439 1.09427 12.0733 1.21498 12.145L2.783 13.0763C2.8409 13.1108 2.88926 13.1591 2.92366 13.217L3.85504 14.785C3.92673 14.9057 4.0561 14.9804 4.19649 14.9822L6.02012 15.0048C6.08746 15.0056 6.15352 15.0233 6.21227 15.0562L7.80287 15.9485C7.92532 16.0172 8.07469 16.0172 8.19715 15.9485L9.78775 15.0562C9.84649 15.0233 9.91255 15.0056 9.97989 15.0048L11.8035 14.9822C11.9439 14.9804 12.0733 14.9057 12.145 14.785L13.0764 13.217C13.1107 13.1591 13.1591 13.1108 13.217 13.0764L14.785 12.145C14.9057 12.0733 14.9804 11.9439 14.9822 11.8035L15.0048 9.97989C15.0056 9.91255 15.0233 9.84649 15.0562 9.78776L15.9485 8.19715C16.0172 8.07467 16.0172 7.92533 15.9485 7.80285L15.0562 6.21224C15.0233 6.15351 15.0056 6.08745 15.0048 6.02011L14.9822 4.19648C14.9804 4.0561 14.9057 3.92673 14.785 3.85502L13.217 2.92363C13.1591 2.88925 13.1107 2.84089 13.0764 2.783L12.145 1.21496C12.0733 1.09425 11.9439 1.01958 11.8035 1.01781L9.97989 0.995235C9.91255 0.994399 9.84649 0.976691 9.78775 0.943783L8.19715 0.0515006ZM6.24868 11.3759C6.40383 11.5322 6.60642 11.6107 6.80981 11.6107C7.0124 11.6107 7.21579 11.5322 7.37094 11.3759L12 6.5C12.3095 6.18672 12.3095 5.67919 12 5.36591C11.6897 5.05184 11.1872 5.05184 10.8777 5.36591L6.80981 9.6736L4.62226 7.5C4.31276 7.18672 3.81031 7.18672 3.5 7.5C3.19049 7.81323 3.19049 8.3216 3.5 8.63488L6.24868 11.3759Z"/></svg><span>' + escapeHtml(verifiedLabel) + '</span></p>' : ''}
            <p class="oskina-avis__quote">${escapeHtml(review.quote)}</p>
            ${photos ? `<div class="oskina-avis__photos">${photos}</div>` : ''}
            ${reply}
          </article>`;
        })
        .join('');
    };

    const pageWindow = (current, total) => {
      if (total <= 5) return Array.from({ length: total }, (_, i) => i + 1);
      let start = Math.max(1, current - 2);
      let end = start + 4;
      if (end > total) {
        end = total;
        start = Math.max(1, end - 4);
      }
      const pages = [];
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    };

    const renderPager = () => {
      const totalPages = Math.max(1, Math.ceil(reviews.length / perPage));
      const nums = pageWindow(page, totalPages);
      pager.innerHTML = `
        <button type="button" data-page="prev" aria-label="${escapeHtml(prevLabel)}"${page === 1 ? ' disabled' : ''}>
          <svg viewBox="0 0 7 12" width="13" height="13"><path d="M6.84 2.066V1.031c0-.09-.104-.14-.173-.084L.629 5.662a.427.427 0 0 0 0 .674l6.038 4.716a.107.107 0 0 0 .173-.085V9.932a.217.217 0 0 0-.082-.169L1.936 6l4.822-3.765a.217.217 0 0 0 .082-.169z" fill="currentColor"/></svg>
        </button>
        ${nums
          .map(
            (n) =>
              `<button type="button" data-page="${n}" class="${n === page ? 'is-active' : ''}" aria-current="${n === page ? 'page' : 'false'}">${n}</button>`
          )
          .join('')}
        <button type="button" data-page="next" aria-label="${escapeHtml(nextLabel)}"${page === totalPages ? ' disabled' : ''}>
          <svg viewBox="0 0 7 12" width="13" height="13"><path d="M6.398 5.663L.36.947a.107.107 0 0 0-.172.085v1.035c0 .065.03.128.081.169L5.091 6 .269 9.765a.213.213 0 0 0-.081.169v1.035c0 .09.103.14.172.084l6.038-4.715a.428.428 0 0 0 0-.675z" fill="currentColor"/></svg>
        </button>
      `;
    };

    const goTo = (nextPage, scroll) => {
      const totalPages = Math.max(1, Math.ceil(reviews.length / perPage));
      page = Math.min(totalPages, Math.max(1, nextPage));
      renderItems();
      renderPager();
      if (scroll) {
        const wrap = document.querySelector('.page-wrapper');
        if (wrap) wrap.scrollTop = root.offsetTop - 12;
      }
    };

    if (!src || !list || !pager) return;

    pager.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-page]');
      if (!button || button.disabled) return;
      const value = button.dataset.page;
      if (value === 'prev') goTo(page - 1, true);
      else if (value === 'next') goTo(page + 1, true);
      else goTo(Number(value), true);
    });

    root.querySelector('[data-avis-open]')?.addEventListener('click', () => dialog?.showModal());
    root.querySelector('[data-avis-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.querySelector('form')?.addEventListener('submit', (event) => {
      event.preventDefault();
      const thanks = dialog.querySelector('.oskina-avis__thanks');
      if (thanks) thanks.hidden = false;
      setTimeout(() => dialog.close(), 900);
    });

    filterBtn?.addEventListener('click', () => {
      if (!sort) return;
      sort.hidden = !sort.hidden;
    });

    sort?.querySelectorAll('li').forEach((option) => {
      option.addEventListener('click', () => {
        const mode = option.dataset.sort;
        const copy = original.slice();
        if (mode === 'high') copy.sort((a, b) => (b.rating || 0) - (a.rating || 0));
        else if (mode === 'low') copy.sort((a, b) => (a.rating || 0) - (b.rating || 0));
        else if (mode === 'newest') copy.reverse();
        reviews = copy;
        sort.hidden = true;
        goTo(1, true);
      });
    });

    fetch(src)
      .then((response) => response.json())
      .then((data) => {
        original = Array.isArray(data) ? data : [];
        reviews = original.slice();
        goTo(1, false);
      })
      .catch(() => {});
  };

  const boot = () => {
    document.querySelectorAll('.oskina-avis').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
